import { type IntlShape } from 'react-intl';

import { type PartnerValidity } from 'components/PartnerDetailsModal/types';
import messages from 'containers/StatusLabels/messages';

/**
 * What a resolved background-check window reads as on a status pill, or
 * `undefined` where no window resolves to a reading and the pill keeps its own
 * priority text.
 */
export const validityText = (
  validity: PartnerValidity | undefined,
  intl: IntlShape,
): string | undefined => {
  // A reading that predates the counter carries no number, and a plural that loses its value renders its own pattern.
  if (validity?.state === 'valid') {
    return typeof validity.days_remaining === 'number'
      ? intl.formatMessage(messages.stillValidFor, {
          count: validity.days_remaining,
        })
      : undefined;
  }
  if (validity?.state === 'expired') {
    return intl.formatMessage(messages.validityWindowClosed);
  }

  return undefined;
};
